function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * done
 */
import { FormPath, onFieldChange } from '@formily/core';
import { useField, useForm, useFormEffects } from '@formily/react';
import { Scope, evalStatement, getType } from '@micun/form-expression';
import { ScopeContext } from '@micun/form-expression/react/index';
import { useContext } from 'react';
import { toAbsPath, useFetch, wrapReactionHook } from "../../hooks";
export var Calculator = wrapReactionHook(function (props) {
  var children = props.children;
  var calculate = props.calculate;
  var _useContext = useContext(ScopeContext),
    scope = _useContext.scope;
  var _useFetch = useFetch(),
    fetch = _useFetch.fetch;

  // console.log('calc render', calculate)

  calculate = Array.isArray(calculate) ? calculate : [calculate];
  var form = useForm();
  var field = useField();
  useFormEffects(function () {
    if (field.designable) {
      return;
    }

    // console.log('calc mount effect', form)
    var getValue = function getValue(value) {
      var depends = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var valueType = getType(value);
      switch (valueType) {
        case 'Object':
          if (value !== null) {
            return Object.keys(value).reduce(function (map, key) {
              map[key] = getValue(value[key], depends);
              return map;
            }, {});
          }
          break;
        case 'Array':
          return value.map(function (i) {
            return getValue(i, depends);
          });
        case 'String':
          if (value[0] === '$') {
            var valuePath = FormPath.parse(value.slice(1), field.path).toString();
            depends.push(valuePath);
            var newScope = new Scope({
              context: form.values,
              parent: scope
            });
            return newScope.get(valuePath);
          }
      }
      return value;
    };
    var loadRemote = function loadRemote(option, values) {
      var url = option.url,
        _option$params = option.params,
        requestParams = _option$params === void 0 ? {} : _option$params,
        mapValue = option.mapValue,
        errorTip = option.errorTip;
      var paramValues = getValue(requestParams);

      // console.log('calc', values, paramValues)
      // if (!values && !paramValues.values) {
      //   console.log('calc value is null', values, paramValues)
      //   return
      // }

      if (!url) {
        console.error('计算组件 url 未配置');
        return;
      }
      var method = option.method,
        dist = option.dist;
      method = "".concat(method || 'get').toLowerCase();
      dist = Array.isArray(dist) ? dist : [dist];
      dist = toAbsPath(dist, field.path);
      var params = paramValues;
      if (values) {
        paramValues.values = values;
      }

      // console.log('load url value', params)

      fetch(_objectSpread({
        url: url,
        method: method,
        // loading: true,
        errorTip: errorTip
      }, method === 'get' ? {
        query: params
      } : {
        data: params
      })).then(function (result) {
        if (result.code === 0) {
          var finalValue;
          if (mapValue) {
            finalValue = FormPath.getIn(result, mapValue);
          } else {
            finalValue = result.data;
          }
          dist.forEach(function (field) {
            form.setValuesIn(field, finalValue);
            Promise.resolve(form.validate(field)).catch(function () {});
          });
        }
      }).catch(function (e) {
        console.error('数据计算接口错误', e, values);
      });
    };
    calculate.forEach(function (option) {
      var type = option.type,
        disableByReadOnly = option.disableByReadOnly;
      var src = option.src,
        dist = option.dist,
        values = option.values,
        condition = option.condition;
      src = Array.isArray(src) ? src : [src];
      dist = Array.isArray(dist) ? dist : [dist];
      var valuesStatements = Array.isArray(values) ? values : [values];
      var conditions = Array.isArray(condition) ? condition : [condition];
      conditions = conditions.filter(function (i) {
        return !!i;
      });
      valuesStatements = valuesStatements.filter(function (i) {
        return !!i;
      });
      src = src.filter(function (i) {
        return !!i;
      });
      dist = dist.filter(function (i) {
        return !!i;
      });
      src = toAbsPath(src, field.path);
      dist = toAbsPath(dist, field.path);
      var depends = [];
      if (type === 'remote') {
        getValue(option.params || {}, depends);
      }
      var onReaction = function onReaction() {
        // console.log('calc field react')
        var context = form.values;
        if (field.readOnly && disableByReadOnly) {
          console.log('calc disabled by readonly', option);
          return;
        }
        if (conditions.length) {
          var conditionResult = evalStatement(conditions, {
            context: context,
            parentScope: scope
          });
          if (!conditionResult) {
            return;
          }
        }
        var result = evalStatement(valuesStatements, {
          context: context,
          parentScope: scope
        });

        // console.log('calc', option, result, valuesStatements)

        if (type === 'remote') {
          loadRemote(option, result);
        } else if (type === 'local') {
          dist.forEach(function (field) {
            form.setValuesIn(field, result);
          });
        }
      };
      var dependFields = Array.from(new Set([].concat(_toConsumableArray(src), depends)));
      // console.log('calc dependFields', dependFields)
      if (dependFields.length) {
        dependFields.forEach(function (field) {
          onFieldChange(field, onReaction);
        });
        // onFieldChange(`*(${src.join(',')})`, onReaction)
      }
    });
  });
  return children;
});